<template>
  <div class="bg-transparent cursor-pointer" @click="this.copy">
    <div v-if="$slots.icon">
      <slot v-if="!this.isCopied" name="icon" />
    </div>
    <div v-else-if="!this.isCopied">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="text-gray-500 hover:text-blue-500"
        :class="this.width"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
        />
      </svg>
    </div>
    <slot v-if="!this.isCopied"></slot>
    <svg
      v-if="this.isCopied"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="text-green-500"
      :class="this.width"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12"
      />
    </svg>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Copy",
  props: {
    value: { type: [String, Number], required: true },
    width: { type: String, required: false, default: "w-5" },
  },
  data() {
    return {
      isCopied: null,
    };
  },
  methods: {
    async copy() {
      if (this.isCopied !== this.value) {
        await navigator.clipboard.writeText(this.value);
        this.isCopied = this.value;
        setTimeout(() => {
          this.isCopied = null;
        }, 2000);
      }
    },
  },
};
</script>
